import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectCard.css';

const ProjectCard = ({ project, user, onTakeProject }) => {
  const completionPercentage = project.completionQuota > 0 
    ? (project.completionCount / project.completionQuota) * 100 
    : 0;

  const handleTakeProject = () => {
    if (onTakeProject) {
      onTakeProject(project);
    }
  };

  return (
    <div className="project-card">
      <div className="project-header">
        <h3 className="project-title">{project.title}</h3>
        <div className="project-status">
          <span className={`status-badge status-${project.status}`}>
            {project.status}
          </span>
        </div>
      </div>
      
      <p className="project-description">{project.description}</p>
      
      <div className="project-meta">
        <div className="project-points">
          <span className="points-icon">💰</span>
          <span className="points-value">{project.pointsReward} points</span>
        </div>
        
        <div className="project-category">
          <span className="category-badge">{project.category}</span>
        </div>
      </div>
      
      {user?.role === 'client' && (
        <div className="project-progress">
          <div className="progress-label">
            <span>Progress</span>
            <span>{project.completionCount}/{project.completionQuota}</span>
          </div>
          <div className="progress-bar-container">
            <div 
              className="progress-bar-fill" 
              style={{ width: `${Math.min(completionPercentage, 100)}%` }}
            />
          </div>
        </div>
      )}
      
      <div className="project-stats">
        <div className="stat">
          <span className="stat-label">Completed</span>
          <span className="stat-value">{project.completionCount}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Terminated</span>
          <span className="stat-value">{project.terminateCount}</span>
        </div>
        {user?.role === 'client' && (
          <div className="stat">
            <span className="stat-label">Spent</span>
            <span className="stat-value">{project.totalSpending}</span>
          </div>
        )}
      </div>
      
      <div className="project-actions">
        {user?.role === 'respondent' && project.status === 'active' && (
          <button 
            onClick={handleTakeProject}
            className="btn btn-primary"
          >
            Take Project
          </button>
        )}
        
        {user?.role === 'client' && (
          <div className="client-actions">
            <Link 
              to={`/projects/${project._id}/edit`} 
              className="btn btn-outline btn-sm"
            >
              Edit
            </Link>
            <Link 
              to={`/projects/${project._id}/responses`} 
              className="btn btn-primary btn-sm"
            >
              View Responses
            </Link>
          </div>
        )}
        
        {user?.role === 'admin' && (
          <div className="admin-actions">
            <Link 
              to={`/admin/projects/${project._id}`} 
              className="btn btn-primary btn-sm"
            >
              Manage
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
